import { render, staticRenderFns } from "./zbsp.vue?vue&type=template&id=760aba1f&scoped=true&"
import script from "./zbsp.vue?vue&type=script&lang=js&"
export * from "./zbsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760aba1f",
  null
  
)

export default component.exports